import React from 'react'
import PropTypes from 'prop-types'

const AgendaSingleItemDatesListItem = ({monthTitle, startDay, timeArray, OnClickPrev, OnClickNext}) => {
	const handleKeyDown = (event, action) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault()
			action()
		}
	}

	return (
		<>
			{monthTitle && (
				<div 
					className="agenda-single-calendar-month-title"
					role="group"
					aria-label={`Navigation du mois ${monthTitle}`}
				>
					<span 
						className="agenda-single-calendar-month-title-prev" 
						onClick={OnClickPrev} 
						onKeyDown={(e) => handleKeyDown(e, OnClickPrev)}
						role="button" 
						tabIndex={0}
						aria-label={`Mois précédent - ${monthTitle}`}
					>
						prev
					</span>
					<span className="agenda-single-calendar-month-title-name">
						{monthTitle}
					</span>
					<span 
						className="agenda-single-calendar-month-title-next" 
						onClick={OnClickNext} 
						onKeyDown={(e) => handleKeyDown(e, OnClickNext)}
						role="button" 
						tabIndex={0}
						aria-label={`Mois suivant - ${monthTitle}`}
					>
						next
					</span>
				</div>
			)}
			{startDay && (
				<div 
					className="agenda-single-calendar-month-day"
					role="group"
					aria-label={`Jour ${startDay} avec horaires`}
				>
					<span className="agenda-single-calendar-month-day-first">
						{startDay}
					</span>
					<span className="agenda-single-calendar-month-day-last">
						{timeArray && timeArray.map((time, index) => 
							<span key={index}>{time[0]} - {time[1]}</span>
						)}
					</span>
				</div>
			)}
		</>
	)
}

AgendaSingleItemDatesListItem.propTypes = {
	monthTitle: PropTypes.string,
	startDay: PropTypes.string,
	timeArray: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
	OnClickPrev: PropTypes.func,
	OnClickNext: PropTypes.func
}

AgendaSingleItemDatesListItem.defaultProps = {
	monthTitle: '',
	startDay: '',
	timeArray: [],
	OnClickPrev: () => {},
	OnClickNext: () => {}
}

export default AgendaSingleItemDatesListItem